import { ShippingType } from "../../../types";
import { Icon } from "../Icon";
import { i18n } from "../../i18n";

export const ProductShippingType = ({
  shippingType,
  shippingPrice,
}: {
  shippingType: ShippingType;
  shippingPrice?: string;
}) => {
  if (shippingType === "FREE") {
    return (
      <p class="tw:text-lg tw:font-semibold tw:text-fruugo-black tw:m-0 tw:flex tw:items-center">
        <Icon
          name="redeem"
          width={20}
          height={20}
          className="tw:w-5 tw:h-5 tw:mr-1 tw:text-fruugo-green"
        />
        {i18n("product.free.shipping")}
      </p>
    );
  }
  if (shippingType === "EXPRESS" && shippingPrice) {
    return (
      <p class="tw:text-lg tw:font-semibold tw:text-fruugo-black tw:m-0 tw:flex tw:items-center">
        <Icon
          name="delivery-truck-speed"
          width={20}
          height={20}
          className="tw:w-5 tw:h-5 tw:mr-1"
          fill="#007cbb"
        />
        {i18n("product.paid.shipping", shippingPrice)}
      </p>
    );
  }
  if (shippingType === "STANDARD" && shippingPrice) {
    return (
      <p class="tw:text-lg tw:font-semibold tw:text-fruugo-black tw:m-0 tw:flex tw:items-center">
        <Icon
          name="package-2"
          width={20}
          height={20}
          className="tw:w-5 tw:h-5 tw:mr-1"
        />
        {i18n("product.paid.shipping", shippingPrice)}
      </p>
    );
  }
};
